import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { unselectSubAgent } from '../../actions/masterFilters';
import { getSubAgents } from '../../actions/subAgents';
import { SelectedSubAgent } from '../../components/SelectedSubAgent';
import { useSubAgentsListOpenTracking } from '../../hooks';
import { masterFiltersSelector, subAgentsSelector } from '../../selectors';
import { closeChat } from '../../actions/chatWindow';

export const SelectedSubAgentContainer = () => {
  const { selectedSubAgentId } = useSelector(masterFiltersSelector);
  const { subAgentsList } = useSelector(subAgentsSelector);

  const dispatch = useDispatch();

  const subAgent = subAgentsList.find(subAgent => subAgent.userId === selectedSubAgentId);

  const handleTracking = useSubAgentsListOpenTracking({ source: 'cross' });

  const handleUnselectSubAgent = React.useCallback(() => {
    dispatch(unselectSubAgent());
    dispatch(getSubAgents({}));
    dispatch(closeChat());
    handleTracking();
  }, [dispatch, handleTracking]);

  if (!selectedSubAgentId || !subAgent) {
    return null;
  }

  return <SelectedSubAgent subAgent={subAgent} onClose={handleUnselectSubAgent} />;
};
